module.exports = __webpack_public_path__ + "img/psicologia-1.67018c10.jpg";